<template>
  <div>
    <b-card-actions action-collapse title="Add Voyage">
      <div>
        <div class="btn-delete-all text-right" @click="saveVoyage()">
          <b-button variant="gradient-primary" class="btn-icon btn-delete-all">
            <feather-icon icon="SaveIcon" />
          </b-button>
        </div>
        <div>
          <b-row>
            <b-col b-col cols="12" lg="6" md="6" sm="12">
              <b-form-group label="Vessel" label-for="vessel">
                <v-select
                  id="vessel"
                  placeholder="Vessel"
                  label="title"
                  :options="vesselArray"
                  v-model="form.vessel"
                >
                </v-select>
              </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="6" md="6" sm="12">
              <b-form-group label="Num Voyage" label-for="num">
                <b-form-input
                  id="num"
                  placeholder="Num Voyage"
                  v-model="form.numero"
                />
              </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="6" md="6" sm="12">
              <b-form-group label="Start date" label-for="start">
                <b-form-datepicker
                  placeholder="Date"
                  v-model="form.startDate"
                  required
                  id="start"
                />
              </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="6" md="6" sm="12">
              <b-form-group label="End date" label-for="end">
                <b-form-datepicker
                placeholder="Date"
                v-model="form.endDate"
                required
                id="end"
                />
              </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="6" md="6" sm="12">
              <b-form-group label="Port of Loading" label-for="loading">
                <v-select
                  id="loading"
                  v-model="form.loadingPort"
                  placeholder="Depart"
                  :options="departArray"
                  @input="updateArrivalPorts(form.loadingPort)"
                >
                </v-select>
              </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="6" md="6" sm="12">
              <b-form-group label="Port of Discharging" label-for="discharging">
                <v-select
                  id="discharging"
                  v-model="form.dischargePort"
                  placeholder="Arrival"
                  :options="arrivalArray"
                  @input="updateDeparturePorts(form.dischargePort)"
                >
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card-actions>

    <b-card-actions action-collapse title="Voyage list">
      <b-row>
        <b-col>
          <div class="custom-search">
            <div class="custom-search d-flex justify-content-end">
              <b-form-group>
                <div class="d-flex align-items-center">
                  <label class="mr-1">Search</label>
                  <b-form-input
                    placeholder="Search"
                    type="text"
                    class="d-inline-block"
                    @input="advanceSearch"
                  />
                </div>
              </b-form-group>
            </div>
          </div>
        </b-col>
      </b-row>
      <vue-good-table
        ref="table-client"
        :columns="columns"
        :rows="rows"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
        theme="my-theme"
      >
        <template
          slot="table-row"
          slot-scope="props"
          class="table-added-element"
        >
          <span v-if="props.column.field === 'action'">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>

                <b-dropdown-item>
                  <feather-icon icon="ExternalLinkIcon" class="mr-50" />
                  <span
                    ><router-link :to="`/detail-voyage?id=${props.row._id}`"
                      >Detail</router-link
                    ></span
                  >
                </b-dropdown-item>

                <b-dropdown-item>
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span
                    ><router-link :to="`/edit-voyage?id=${props.row._id}`"
                      >Update</router-link
                    ></span
                  >
                </b-dropdown-item>
                <b-dropdown-item @click="deleteVoyage(props.row._id)">
                  <feather-icon icon="TrashIcon" class="mr-50" />
                  <span>Delete</span>
                </b-dropdown-item>
                <b-dropdown-item>
                  <feather-icon icon="ListIcon" class="mr-50" />
                  <span
                    ><router-link :to="`/list-bookings?id=${props.row._id}&text=voyage`"
                      >List of Bookings</router-link
                    ></span
                  >
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span>
          <span v-if="props.column.field === 'details'">
            <ul style="list-style: none;padding: 0;">
              <li v-for="(item, i) in props.row.stopovers" :key="i">
               <strong> {{ item.loadingPort }} </strong>{{"-->"}} <strong>{{ item.dischargePort }}</strong><br>
                <span> {{ formatDate(item.startDate) }} {{"-->"}} {{ formatDate(item.endDate) }}</span>
              </li>
            </ul>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to </span>
              <b-form-select
                v-model="pageLength"
                :options="['3', '5', '10']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </b-card-actions>

    <b-card-actions action-collapse title="Transshipment list">
      <b-row>
        <b-col class="d-flex justify-content-end">
          <div class="custom-search mr-1">
            <div class="custom-search d-flex justify-content-end">
              <b-form-group>
                <div class="d-flex align-items-center">
                  <label class="mr-1">Search</label>
                  <b-form-input
                    placeholder="Search"
                    type="text"
                    class="d-inline-block"
                    @input="advanceSearchTrans"
                  />
                </div>
              </b-form-group>
            </div>      
          </div>
          <div class="btn-delete-all text-right">
            <b-button variant="gradient-primary" class="btn-icon" @click="downloadXLSX">
              Download
              <feather-icon icon="DownloadIcon" />
            </b-button>
            <!--<vue-xlsx-table @on-select-file="uploadXLSX" class="btn-icon-upload">
              Upload
              <feather-icon icon="UploadIcon" />
           </vue-xlsx-table>-->
          </div>
        </b-col>
      </b-row>
      <vue-good-table
        ref="table-client"
        :columns="transColumns"
        :rows="transRows"
        :search-options="{
          enabled: true,
          externalQuery: searchTermTrans,
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLengthTrans,
        }"
        theme="my-theme"
      >
        <template
          slot="table-row"
          slot-scope="props"
          class="table-added-element"
        >
          <span v-if="props.column.field === 'action'">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>

                <b-dropdown-item>
                  <feather-icon icon="ListIcon" class="mr-50" />
                  <span
                    ><router-link :to="`/list-bookings?id=${props.row._id}&text=transshipment`"
                      >List of Bookings</router-link
                    ></span
                  >
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to </span>
              <b-form-select
                v-model="pageLengthTrans"
                :options="['3', '5', '10']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLengthTrans"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </b-card-actions>
  </div>
</template>

<script>
import moment from 'moment';
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BFormSelect,
  BFormDatepicker,
  BAvatar,
  BPagination,
  BImg,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import * as XLSX from 'xlsx';

export default {
  components: {
    BDropdown,
    BDropdownItem,
    ToastificationContent,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BCardActions,
    BFormSelect,
    vSelect,
    BFormDatepicker,
    BAvatar,
    BPagination,
    BImg,
    VueGoodTable,
    XLSX
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      json_data: [],
      json_fields: {
        society: "society",
        Nom: "firstName",
        Prenom: "lastName",
        Email: "email",
        Cite: "city",
        numero: "telNumbers",
        "Matricule Fiscale": "registrationNumber",
      },
      form : {
        numero : '',
        vessel : '',
        loadingPort : '',
        dischargePort : '',
        startDate : '',
        endDate : '',
        stopovers : [],
      },
      vesselArray: [],
      ports: [],
      departArray: [],
      arrivalArray: [],
      nextTodoId: 2,
      pageLength: 5,
      pageLengthTrans: 5,
      dir: false,
      columns: [
        {
          label: "Action",
          field: "action",
          sortable: false,
        },
        {
          label: "Vessel",
          field: "vessel",
          filterOptions: {
            enabled: true,
            placeholder: "Vessel",
          },
        },
        {
          label: "Num Voyage",
          field: "numero",
          filterOptions: {
            enabled: true,
            placeholder: "Num Voyage",
          },
        },
        {
          label: "Port of Loading",
          field: "loadingPort",
          filterOptions: {
            enabled: true,
            placeholder: "Port of Loading",
          },
        },
        {
          label: "Port of Discharing",
          field: "dischargePort",
          filterOptions: {
            enabled: true,
            placeholder: "Port of Discharing",
          },
        },
        {
          label: "Start Date",
          field: "startDate",
          filterOptions: {
            enabled: true,
            placeholder: "Start Date",
          },
          formatFn: (value) => {
            return moment(value).format('MM/DD/YYYY');
          },
        },
        {
          label: "End Date",
          field: "endDate",
          filterOptions: {
            enabled: true,
            placeholder: "End Date",
          },
          formatFn: (value) => {
            return moment(value).format('MM/DD/YYYY');
          },
        },
        {
          width : '280px',
          label: "Details",
          field: "details",
          filterOptions: {
            enabled: true,
            placeholder: "Details",
          },
        }
      ],
      transColumns: [
        {
          label: "Action",
          field: "action",
          sortable: false,
        },
        {
          label: "Vessel",
          field: "vessel",
          filterOptions: {
            enabled: true,
            placeholder: "Vessel",
          },
        },
        {
          label: "Num Voyage",
          field: "numero",
          filterOptions: {
            enabled: true,
            placeholder: "Num Voyage",
          },
        },
        {
          label: "Port of Loading",
          field: "loadingPort",
          filterOptions: {
            enabled: true,
            placeholder: "Port of Loading",
          },
        },
        {
          label: "Port of Discharing",
          field: "dischargePort",
          filterOptions: {
            enabled: true,
            placeholder: "Port of Discharing",
          },
        },
        {
          label: "Start Date",
          field: "startDate",
          filterOptions: {
            enabled: true,
            placeholder: "Start Date",
          },
          formatFn: (value) => {
            return moment(value).format('MM/DD/YYYY');
          },
        },
        {
          label: "End Date",
          field: "endDate",
          filterOptions: {
            enabled: true,
            placeholder: "End Date",
          },
          formatFn: (value) => {
            return moment(value).format('MM/DD/YYYY');
          },
        },
      ],
      rows: [],
      transRows: [],
      searchTerm: "",
      searchTermTrans: "",
    };
  },
  mounted() {
    //this.initTrHeight()
  },
  async created() {
    window.addEventListener("resize", this.initTrHeight);
    await this.getVessels()
    await this.getPorts()
    await this.getDataManagement();
    await this.getTransshipment()
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    async getVessels() {
      this.vesselArray = [];
      const response = await axios.get("https://mtl-feeder-nodejs.onrender.com/api/vessels");
      response.data.data.forEach(element => {
        this.vesselArray.push(element.title)
      });
    },
    async getPorts() {
      const response = await axios.get("https://mtl-feeder-nodejs.onrender.com/api/ports")
      response.data.data.forEach((element,index) => {
        this.ports.push({
          "label" : element.title,
          "value" : element._id
        })  
      });   
      this.departArray = this.ports
      this.arrivalArray = this.ports
    },
    updateArrivalPorts(port) {
      this.form.loadingPort = port ? port.label : ''
      this.arrivalArray = port ? this.ports.filter(item => item.value !== port.value) : this.ports
    },
    updateDeparturePorts(port) {
      this.form.dischargePort = port ? port.label : ''
      this.departArray = port ? this.ports.filter(item => item.value !== port.value) : this.ports
    },
    saveVoyage() {
      if (Object.values(this.form).some(value => value === '' || value === null)) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Fill out the form",
            icon: "EditIcon",
            variant: "warning",
          },
        });      
      }
      else {
        axios.post("https://mtl-feeder-nodejs.onrender.com/api/voyages", this.form)
        .then(async (response) => {
          await this.getDataManagement()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "voyage added",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during add",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });
      }
    },
    async getDataManagement() {
      const response = await axios.get("https://mtl-feeder-nodejs.onrender.com/api/voyages")
      this.rows = response.data.data
    },
    async getTransshipment() {
      const response = await axios.get("https://mtl-feeder-nodejs.onrender.com/api/transshipment")
      this.transRows = response.data.data   
    },
    deleteVoyage(id) {
      this.$swal({
        title: "You really want to delete this voyage ?",
        text: "You can't undo this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirm !",
        cancelButtonText: "Cancel !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axios.delete(`https://mtl-feeder-nodejs.onrender.com/api/voyages/${id}`)
            .then((response) => {
              this.getDataManagement();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Voyage deleted`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Error while deleting`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action canceled",
            icon: "error",
            confirmButtonText: "Close !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    advanceSearch(val) {
      this.searchTerm = val;
    },
    advanceSearchTrans(val) {
      this.searchTermTrans = val;
    },
    formatDate(date) {
      return moment(date).format('MM/DD/YYYY');
    },
    downloadXLSX() {
      const data = [];
      this.transRows.forEach((voyage) => {
        data.push({
          "Vessel" : voyage.vessel ? voyage.vessel : "",
          "Num Voyage" : voyage.numero ? voyage.numero : "",
          "Loading Port" : voyage.loadingPort,
          "Discharge Port" : voyage.dischargePort,
          "Start Date" : moment(voyage.startDate).format('MM/DD/YYYY'),
          "End Date" : moment(voyage.endDate).format('MM/DD/YYYY'),
        })
      })
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Transshipments');
      XLSX.writeFile(workbook, 'Transshipment.xlsx');
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-select.scss";
.vs__dropdown-toggle {
  border: 1px solid #d8d6de !important;
}
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
.btn-add {
  margin-top: 20px;
}
</style>